import { createContext, useContext, useState, useEffect } from 'react';
import { API_BASE_URL } from '../utils/apiConfig.js';

const SessionContext = createContext();

function generateSessionId() {
    return Math.random().toString(36).substring(2) + Date.now().toString(36);
}

export function SessionProvider({ children, userRole }) {
    const [sessionId, setSessionId] = useState(localStorage.getItem('sessionId'));
    const [cartId, setCartId] = useState(localStorage.getItem('cartId'));
    const [experimentId, setExperimentId] = useState(localStorage.getItem('experimentId') || 1);
    
    useEffect(() => {
        const storedRole = localStorage.getItem("userRole");
        const isResearcher = userRole === 'researcher' || storedRole === 'researcher';

        const initializeSession = async () => {
            // 1. Get or Generate Session ID
            let currentSess = localStorage.getItem('sessionId');
            if (!currentSess) {
                currentSess = isResearcher ? `RESEARCH_${generateSessionId()}` : generateSessionId();
                localStorage.setItem('sessionId', currentSess);
            }
            setSessionId(currentSess);

            // 2. Handle Experiment ID
            let currentExp = localStorage.getItem('experimentId');
            if (currentExp) {
                setExperimentId(parseInt(currentExp));
            } else {
                setExperimentId(1);
            }
        
            // 3. Handle Cart
            let currentCart = localStorage.getItem('cartId');
            if (!currentCart) {
                await createCart(currentSess);
            } else {
                setCartId(currentCart);
            }
        };

        initializeSession();
    }, [userRole]);

    const updateExperimentId = (id) => {
        localStorage.setItem('experimentId', id);
        setExperimentId(id);
    };

    const createCart = async (sId) => {
        try {
            const res = await fetch(`${API_BASE_URL}/api/cart`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ sessionId: sId })
            });
            const data = await res.json();
        
            if(data.cartId) {
                localStorage.setItem('cartId', data.cartId);
                setCartId(data.cartId);
                // Trigger navbar refresh
                window.dispatchEvent(new Event("cartUpdated"));
            }
        } catch (err) {
            console.error('Error creating cart:', err);
        }
    };
    
    return (
        <SessionContext.Provider value={{ sessionId, cartId, experimentId, setExperimentId: updateExperimentId }}>
            {children}
        </SessionContext.Provider>
    );
}

export function useSession() {
    return useContext(SessionContext);
}